import Autocomplete from "@mui/material/Autocomplete"
import TextField from "@mui/material/TextField"

function SearchAutoComplete(props) {
  const handleInputChange = (event, newValue) => {
    props.onChange(newValue, props?.label)
  }

  // Make the options distinct
  const distinctOptions = [...new Set(props.options)]

  return (
    <Autocomplete
      freeSolo
      options={distinctOptions}
      renderInput={(params) => <TextField {...params} label={props?.label} />}
      style={{ padding: "5px" }}
      onInputChange={handleInputChange}
    />
  )
}

export default SearchAutoComplete
